module.exports = __webpack_public_path__ + "img/web-dev.483a2b19.jpg";